export default function LanderCardImage({
	image,
	imageAlt,
	title,
	description,
	features,
}: {
	readonly image: string;
	readonly imageAlt: string;
	readonly title: string;
	readonly description: string;
	readonly features: [string, string][];
}) {
	return (
		<div>
			<div className="relative">
				<img
					alt={imageAlt}
					src={image}
					className="h-[520px] w-full object-cover"
				/>
				<div className="absolute bottom-0 p-6 bg-gradient-to-b from-transparent via-black/75 to-black w-full pt-12">
					<h3 className="text-amber-500 font-heading text-4xl font-semibold pb-1">
						{title}
					</h3>
					<h4>{description}</h4>
				</div>
			</div>

			{features.length > 0 && (
				<div className="even:bg-agate-900/50 odd:bg-agate-800/40">
					{features.map(([feature, featureDesc]) => (
						<div
							key={`lander-card-feature-${title}-${feature}`}
							className="p-4 border-b border-l border-r border-slate-800"
						>
							<p className="text-xl text-amber-500 font-heading">{feature}</p>
							<p className="opacity-85">{featureDesc}</p>
						</div>
					))}
				</div>
			)}
		</div>
	);
}
